<template>
    <div id="uploader">
        <div
        is="Steps"
        :current_step="current_step"
        :checked_count="checked_operation_count"
        :uploaded_count="uploaded_operation_count"
        :data_count="operations_count"
        :is_processing="is_processing"
        >
        </div>
        <div class="ui divider"></div>
        <div class="ui indicating complete progress" v-if="is_processing" id="index-progress-bar">
            <div class="bar">
                <div class="progress"></div>
            </div>
        </div>

        <ErrorBox :errors="errors" />

        <div v-if="!is_initialized">
            <div class="ui inverted dimmer transition visible active" style="display: block !important;">
                <div class="ui text loader">{{ $t('ui.general.initializing') }}</div>
            </div>
        </div>
        <div v-else class="basic_options">
            <div
            class="ui top attached mini segment"
            :class="{
                'green': basic_options_setted,
                'orange': !basic_options_setted
            }">
                <h3 class="ui header">
                    <i class="upload icon"></i>
                    <div class="content">
                        <!-- 上傳託運總表 -->
                        {{ $t('ui.pages.uploader.upload_operation_list') }}
                    </div>
                </h3>
            </div>
            <div class="ui bottom attached segment">
                <div class="ui grid">
                    <div class="eight wide column">
                        <div class="ui segments">
                            <div class="ui segment">
                                <!-- 檔案名稱： -->
                                {{ $t('ui.pages.uploader.file.name') }}：
                                <span>{{ file_name || 'N/A' }}</span>
                            </div>
                            <div class="ui segment">
                                <!-- 檔案大小： -->
                                {{ $t('ui.pages.uploader.file.size') }}：
                                <span>{{ file_size_in_bytes }} Bytes / 1024000 Bytes</span>
                            </div>
                            <div class="ui segment">
                                <!-- 檔案下載路徑： -->
                                {{ $t('ui.pages.uploader.file.path') }}：
                                <span v-if="is_file_uploaded">
                                    <a :href="file_s3_path">{{ file_name }}</a>
                                </span>
                                <span v-else>N/A</span>
                            </div>
                            <div class="ui segment">
                                <!-- 檔案上傳： -->
                                {{ $t('ui.pages.uploader.file.upload') }}：
                                <span v-if="is_file_uploaded"><i class="check icon"></i>
                                    <!-- 完成 -->
                                    {{ $t('ui.pages.uploader.file.complete') }}
                                </span>
                                <span v-else><i class="warning icon"></i>
                                    <!-- 尚未上傳 -->
                                    {{ $t('ui.pages.uploader.file.not_uploaded') }}
                                </span>

                            </div>
                        </div>
                    </div>
                    <div class="eight wide column ui form" v-if="basic_options_setted">
                        <div class="field">
                            <label>
                                {{ $t('ui.general.please_select') }}
                                <!-- 託運總表 -->
                                {{ $t('ui.pages.uploader.operation_list') }}
                            </label>
                            <span>
                                <!-- 已選擇 -->
                                {{ $t('ui.pages.uploader.selected') }}
                                【{{ file_name }}】
                            </span>
                        </div>
                        <div class="field">
                            <label>
                                {{ $t('ui.general.please_select') }}
                                {{ $t('models.attributes.core_waybills.sender') }}
                            </label>
                            <span>
                                <!-- 已選擇 -->
                                {{ $t('ui.pages.uploader.selected') }}
                                {{ requester_node.company_name }}
                            </span>
                        </div>
                        <div class="field">
                            <label>
                                {{ $t('ui.general.please_select') }}
                                <!-- 合約 -->
                                {{ $t('ui.pages.uploader.contract') }}
                            </label>
                            <span>
                                <!-- 已選擇 -->
                                {{ $t('ui.pages.uploader.selected') }}
                                {{ requester_contract.name }}
                            </span>
                        </div>
                        <div class="field">
                            <label>
                                <!-- 您的動作 -->
                                {{ $t('ui.pages.uploader.your_actions') }}
                            </label>
                            <span>{{ current_converter.name }}</span>
                        </div>
                    </div>

                </div>
                <div class="ui divider"></div>
                <div v-if="basic_options_setted">
                    <a v-if="(is_processing || !can_next_step) && current_step < 4" class="ui large fluid primary button disabled">
                        <!-- 處理中... -->
                        {{ $t('ui.general.initializing') }}
                    </a>
                    <a v-else-if="current_step < 4" class="ui large fluid primary button" @click="steps_callback_center(current_step)">
                        <!-- 確認送出 -->
                        {{ $t('ui.general.submit') }}
                    </a>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <div class="ui divider"></div>
        <div v-if="current_step >= 4">
            <div class="ui icon positive message">
                <i class="check icon"></i>
                <div class="content">
                    <div class="header">
                        <!-- 明細上傳完畢 -->
                        {{ $t('ui.pages.uploader.upload_detail_completed') }}
                    </div>
                    <p>
                        <button class="ui primary button" @click="init">
                            <!-- 繼續上傳下一份文件 -->
                            {{ $t('ui.pages.uploader.continue_next_file') }}
                        </button>
                    </p>
                </div>
            </div>
        </div>
        <div class="operations_dashboard">
            <div is="Operation" v-for="(receiver, index) in receivers" :receiver="receiver" :index="index"></div>
        </div>
        <div class="ui dimmer" ref="operation_target_selector" v-if="is_initialized">
            <div class="content" ref="converters">
                <h1>
                    <!-- 您現在想要... -->
                    {{ $t('ui.pages.uploader.dimmer.what_do_you_want_now') }}...
                </h1>
                <div class="ui link cards">
                    <div
                        class="card"
                        v-for="converter in converters"
                        >
                        <div class="content" @click="
                        $store.commit(current_scope + '/uploader_module/set_current_converter', converter);
                        $($refs.converters).hide();
                        $($refs.file_selector).show();">
                            <div class="header">
                                {{ converter.name }}
                            </div>
                            <div class="description">
                                {{ converter.note }}
                            </div>
                        </div>
                        <div class="extra content" v-if="converter.sample_file_url">
                            <a :href="converter.sample_file_url" class="right floated star">
                                <div class="ui circular icon button">
                                    <i class="download icon"></i>
                                </div>
                                <span>
                                    <!-- 下載文件 -->
                                    {{ $t('ui.pages.uploader.dimmer.download_sample_file') }}
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content" ref="file_selector" style="display:none;">
                <h1>
                    <!-- 請上傳您的檔案... -->
                    {{ $t('ui.pages.uploader.dimmer.please_upload_your_file') }}...
                </h1>
                <div class="ui link cards">
                    <div class="card">
                        <div class="content">
                            <div class="header">
                                <!-- 選擇檔案 -->
                                {{ $t('ui.pages.uploader.dimmer.select_file') }}
                            </div>
                            <div class="description">
                                <input
                                    ref="file_input_field"
                                    type="file"
                                    @change="select_file($event)">
                            </div>
                        </div>
                    </div>
                    <div class="card" @click="init">
                        <div class="content">
                            <div class="header">
                                <!-- 重做 -->
                                {{ $t('ui.pages.uploader.redo') }}
                            </div>
                            <div class="description">
                                <!-- 點擊這張卡片重新開始 -->
                                {{ $t('ui.pages.uploader.dimmer.clicked_this_card_redo') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content" ref="requester_selector" style="display:none;">
                <h1>
                    {{ $t('ui.general.please_select') }}
                    {{ $t('models.attributes.core_waybills.sender') }}...
                </h1>
                <div class="ui link cards">
                    <div class="card">
                        <div class="content">
                            <div class="header">
                                <div class="ui selection dropdown" v-dropdown>
                                    <i class="dropdown icon"></i>
                                    <div class="default text">
                                        {{ $t('ui.general.please_select') }}
                                        {{ $t('models.attributes.core_waybills.sender') }}
                                    </div>
                                    <div class="menu">
                                        <div
                                            class="item"
                                            v-for="customer in customers"
                                            @click="
                                            $store.commit(current_scope + '/uploader_module/set_requester_node', customer);
                                            if (customer.contracts.length == 1) {
                                                $store.commit(current_scope + '/uploader_module/set_requester_contract', customer.contracts[0]);
                                                $($refs.requester_selector).hide();
                                                $($refs.loader).show();
                                                steps_callback_center(1);
                                            }">
                                                {{ customer.company_name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="description" v-if="current_scoped_store.uploader_module.requester_node">
                                <div class="ui selection dropdown" v-dropdown>
                                    <i class="dropdown icon"></i>
                                    <div class="default text">
                                        <!-- 選擇合約 -->
                                        {{ $t('ui.general.please_select') }}
                                        {{ $t('ui.pages.uploader.contract') }}
                                    </div>
                                    <div class="menu">
                                        <div
                                            class="item"
                                            v-for="contract in current_scoped_store.uploader_module.requester_node.contracts"
                                            @click="
                                                $store.commit(current_scope + '/uploader_module/set_requester_contract', contract);
                                                $($refs.requester_selector).hide();
                                                $($refs.loader).show();
                                                steps_callback_center(1);">
                                                {{ contract.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card" @click="init">
                        <div class="content">
                            <div class="header">
                                <!-- 重做 -->
                                {{ $t('ui.pages.uploader.redo') }}
                            </div>
                            <div class="description">
                                <!-- 點擊這張卡片重新開始 -->
                                {{ $t('ui.pages.uploader.dimmer.clicked_this_card_redo') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content" ref="loader" style="display:none;">
                <div class="ui text loader">Loading</div>
            </div>
        </div>
        <div is="BackToTopButton"></div>
    </div>
</template>

<script>
import Steps from '../.components/operations/steps.vue'
import Operation from '../.components/operations/operation.vue'
import ErrorBox from '../.components/errors.vue'
import BackToTopButton from '@toolbox/back_to_top_button/main.vue'

export default {
    name: "UploaderIndex",
    data() {
        return {
            // Loading controller
            is_initialized: false,
            is_processing: false,
            can_next_step: true,
            // Datas
            basic_options_setted: false,
            operations_count: 0,
            complete_operation_count: 0,
            checked_operation_count: 0,
            uploaded_operation_count: 0,
            current_step: 1,
            current_operation_index: 0,
            // File
            excel_file: null,
            file_name: null,
            file_size_in_bytes: 0,
            file_s3_path: null,
            is_file_uploaded: false,
            // flags
            is_queue_mode: true,
            // Error Messages
            errors: [],
        }
    },
    computed: {
        current_scope() {
            return this.$store.state.current_scope
        },
        current_scoped_store() {
            return this.$store.state[this.current_scope]
        },
        receivers() {
            return this.current_scoped_store.uploader_module.receivers
        },
        customers() {
            return this.current_scoped_store.uploader_module.customers
        },
        requester_node: {
            get () {
                return this.current_scoped_store.uploader_module.requester_node
            },
            set (value) {
                this.$store.commit(this.current_scope + "/uploader_module/set_requester_node", value)
            }
        },
        requester_contract: {
            get () {
                return this.current_scoped_store.uploader_module.requester_contract
            },
        },
        fetch_customers_url() {
            return this.current_scoped_store.uploader_module.fetch_customers_url
        },
        open_file_url() {
            return this.current_scoped_store.uploader_module.open_file_url
        },
        file_upload_url() {
            return this.current_scoped_store.uploader_module.file_upload_url
        },
        converters() {
            return this.current_scoped_store.uploader_module.converters
        },
        current_converter() {
            return this.current_scoped_store.uploader_module.current_converter || {name: null}
        },
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })

        // Index&Operations Interactions
        this.$bus.$off("to_index")
        this.$bus.$on("to_index", (mission, operation_index) => {
            switch (mission) {
                case "validate_waybills":
                    this.checked_operation_count++
                    if (this.receivers[operation_index+1]) {
                        this.current_operation_index ++
                        this.$bus.$emit('to_operations', "validate_waybills", this.current_operation_index)
                    } else {
                        this.steps_callback_center("validate_waybills")
                    }
                    break
                case "create_operation":
                    this.uploaded_operation_count++
                    if (this.receivers[operation_index+1]) {
                        this.current_operation_index ++
                        this.$bus.$emit('to_operations', "create_operation", this.current_operation_index)
                    } else {
                        this.steps_callback_center("create_operations")
                    }
                    break
                case "complete":
                    this.complete_operation_count++
                    $('#index-progress-bar').progress({
                        duration : 300,
                        value    : this.complete_operation_count,
                        total    : this.operations_count
                    })
                case "interrupt":
                    this.steps_callback_center("interrupt")
                default:
            }
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    watch: {
    },
    methods: {
        // 初始化流程
        async init() {
            await new Promise(resolve => {
                $(this.$refs.operation_target_selector).dimmer('hide')
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.can_next_step = true
                this.basic_options_setted = false
                this.operations_count = 0
                this.complete_operation_count = 0
                this.checked_operation_count = 0
                this.uploaded_operation_count = 0
                this.current_step = 1
                this.current_operation_index = 0
                this.excel_file = null
                this.file_name = null
                this.file_size_in_bytes = 0
                this.file_s3_path = null
                this.is_file_uploaded = false
                this.is_queue_mode = true
                this.errors = []
                resolve()
            })
            await this.$store.commit(this.current_scope + "/uploader_module/init")
            await this.$store.dispatch(this.current_scope + '/uploader_module/set_urls')
            await this.$store.dispatch(this.current_scope + "/uploader_module/fetch_customers")
            await this.$store.dispatch(this.current_scope + "/uploader_module/fetch_operator_node")
            await this.$store.dispatch(this.current_scope + "/uploader_module/fetch_converters")
            await new Promise(resolve => {
                this.$noty.information(
                    this.$t("ui.page_titles.uploader") + ' ' +
                    this.$t('ui.general.initialize_complete')
                )
                this.is_initialized = true
                resolve()
            })
            await new Promise(resolve => {
                $(this.$refs.operation_target_selector).dimmer('show')
                resolve()
            })
        },
        // Actions
        select_file(e) {
            this.excel_file = e.target.files[0]
            this.file_name = this.excel_file.name
            this.file_size_in_bytes = this.excel_file.size
            // behavior control
            $(this.$refs.file_input_field).val('')
            $(this.$refs.file_selector).hide()
            if (this.current_converter.ignore_customer_node) {
                $(this.$refs.loader).show()
                this.steps_callback_center(1)
                // this.requester_node = {name: this.current_converter.name, identity: null}
            } else {
                $(this.$refs.requester_selector).show()
            }
        },
        open_file() {
            this.is_processing = true
            this.errors = []
            if(this.excel_file == null || this.excel_file == undefined) {
                // this.errors.push("請先選擇檔案")
                this.errors.push(
                    this.$t('ui.pages.uploader.dimmer.select_file')
                )
            }
            if(this.requester_node == null) {
                this.$store.commit(this.current_scope + '/uploader_module/set_requester_node', {company_en_name: ""})
                this.$store.commit(this.current_scope + '/uploader_module/set_requester_contract', {name: ""})
            }
            var url = new RestUrl(this.open_file_url).parse(
                {
                    "converter_identity": this.$store.state.provider.uploader_module.current_converter.identity
                },
                ""
            )
            if (this.errors.length == 0) {
                var form_data = new FormData()
                form_data.append('excel_file', this.excel_file)
                form_data.append('file_name', this.file_name)
                form_data.append('file_size_in_bytes', this.file_size_in_bytes)
                form_data.append('provider', this.current_converter.provider)
                form_data.append('category', this.current_converter.category)
                axios.post(
                        url,
                        form_data,
                        {headers: { Authorization: localStorage.getItem("authentication_token") }}
                    )
                    .then(response => {
                        if (response.data.status == "failure") {
                            _.forEach(response.data.errors, (error, key) => {
                                _.forEach(error, (message, key) => {
                                    // this.errors.push("開啟文件失敗: " + message)
                                    this.errors.push(
                                        this.$t('ui.pages.uploader.open_file') + " " +
                                        this.$t('ui.general.failure') + ": " +
                                        message
                                    )
                                })
                            })
                            this.steps_callback_center("interrupt")
                        } else {
                            this.$store.commit(this.current_scope + "/uploader_module/set_conversions", response.data.conversions)
                            this.$store.commit(this.current_scope + "/uploader_module/set_waybill_raw_datas", {
                                "託運": response.data.human_datas
                            })
                            this.$store.commit(this.current_scope + "/uploader_module/set_waybill_processed_datas", {
                                "託運": response.data.processed_datas
                            })
                            this.$store.commit(this.current_scope + "/uploader_module/set_receivers", [
                                "託運"
                            ])
                            this.operations_count = this.receivers.length
                            this.basic_options_setted = true
                            this.steps_callback_center("open_file")
                            $(this.$refs.operation_target_selector).dimmer('hide')
                            $(this.$refs.loader).hide()
                            $(this.$refs.converter_selector).show()
                        }
                    })
                    .catch(error => {
                        _.forEach(response.data.errors, (error, key) => {
                            _.forEach(error, (message, key) => {
                                // this.errors.push("開啟文件失敗: " + message)
                                this.errors.push(
                                    this.$t('ui.pages.uploader.open_file') + " " +
                                    this.$t('ui.general.failure') + ": " +
                                    message
                                )
                            })
                        })
                        this.steps_callback_center("interrupt")
                    })
            } else {
                this.steps_callback_center("interrupt")
            }
        },
        upload_file(e) {
            if(this.excel_file !== null && this.excel_file !== undefined) {
                if (this.is_file_uploaded == true) {
                    this.steps_callback_center("upload_file")
                } else {
                    var form_data = new FormData()
                    form_data.append('file', this.excel_file)
                    axios.post(
                        this.file_upload_url,
                        form_data)
                       .then(response => {
                           if (response.data.link) {
                               this.is_file_uploaded = true
                               this.file_s3_path = decodeURIComponent(response.data.link)
                               // "檔案上傳成功"
                               this.$noty.success(
                                   this.$t('ui.notifications.success.upload__name', {
                                       name: this.$t('ui.general.file')
                                   })
                               )

                               this.steps_callback_center("upload_file")
                           } else {
                               return Promise.reject(response)
                           }
                       })
                       .catch(error => {
                           // this.$noty.error("檔案上傳失敗")
                           this.$noty.error(
                               this.$t('ui.notifications.error.upload__name', {
                                   name: this.$t('ui.general.file')
                               })
                           )
                           this.errors.push(
                               this.$t('ui.notifications.error.upload__name', {
                                   name: this.$t('ui.general.file'),
                                   reason: ': '+this.$t('ui.general.network_abnormality')
                               })
                           )
                           this.steps_callback_center("interrupt")
                       })
                }
            } else {
                // this.errors.push("未選擇檔案")
                this.errors.push(
                    this.$t('ui.general.no') + " " +
                    this.$t('ui.pages.uploader.dimmer.select_file')
                )
                this.steps_callback_center("interrupt")
            }
        },
        // Actions2
        validate_waybills() {
            this.$bus.$emit('to_operations', "validate_waybills", this.current_operation_index)
        },
        create_operations() {
            this.$bus.$emit('to_operations', "create_operation", this.current_operation_index)
        },
        // 流程控制
        steps_callback_center(flag) {
            switch (flag) {
                case 1:
                    this.is_processing = true
                    this.open_file()
                    break
                case 2:
                    this.is_processing = true
                    this.validate_waybills()
                    break
                case 3:
                    this.is_processing = true
                    this.upload_file()
                    break
                case 4:
                    var operation_components = _.filter(this.$children, (o) => { return o.$options._componentTag == "Operation" })
                    if (operation_components.length == 1 && !(this.current_converter.skip_operation_creation && this.current_converter.skip_usable_validation)) {
                        this.$router.push({name: 'edit_provider_operation', params: {identity: operation_components[0].operation.identity}})
                    } else {

                    }
                    break
                case "open_file":
                    this.current_step++
                    this.is_processing = false
                    this.$nextTick(() => {
                        this.steps_callback_center(2)
                    })
                    break
                case "validate_waybills":
                    this.current_operation_index = 0
                    this.complete_operation_count = 0
                    this.is_processing = false
                    this.current_step++
                    break
                case "upload_file":
                    this.create_operations()
                    break
                case "create_operations":
                    this.current_operation_index = 0
                    this.complete_operation_count = 0
                    this.is_processing = false
                    this.current_step++
                    this.$nextTick(() => {
                        this.steps_callback_center(4)
                    })
                    break
                case "interrupt":
                    $(this.$refs.operation_target_selector).dimmer('show')
                    $(this.$refs.operation_target_selector).dimmer('hide')
                    this.is_processing = false
                    break
                default:
            }
        }
    },
    components: {
        Steps,
        Operation,
        ErrorBox,
        BackToTopButton
    }
}
</script>
<style lang="scss">
    @import "../.assets/stylesheets/index.scss";
    #uploader {
        min-height: 100vh;
    }
    .ui.dimmer {
        overflow-y: scroll;
    }
</style>
<style scoped lang="scss">
    @media only screen and (max-width: 1800px) {
        .ui.dimmer .content .ui.link.cards {
            justify-content:center;
        }
    }
</style>
